import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { HRDashBoard } from '../../modules/ComponentsLibrary/HRDashboard';
import { hrDashboardTabsIds } from '../../modules/ComponentsLibrary/HRDashboard/constants';

export const Route = createFileRoute('/hrDashboard/')({
  component: RouteComponent,
  validateSearch: z.object({
    defaultTabId: z.enum(hrDashboardTabsIds).optional(),
    // Termination tab: opens the record form as a full-screen dialog over the
    // dashboard (keeps its filters/sort/page/scroll mounted). Kept in the URL so
    // browser back closes the dialog and a refresh reopens the same record.
    terminationEditUserId: z.number().int().positive().optional().catch(undefined),
    terminationCreate: z.boolean().optional().catch(undefined),
    // New Hire tab: same full-screen-dialog pattern as Termination.
    newHireEditId: z.number().int().positive().optional().catch(undefined),
    newHireCreate: z.boolean().optional().catch(undefined),
  }),
  head(ctx) {
    return {
      meta: [{ title: 'HR Dashboard' }],
    };
  },
});

function RouteComponent() {
  const searchParams = Route.useSearch();
  return <HRDashBoard prId={0} defaultTabId={searchParams.defaultTabId || '0'} />;
}
